export default __webpack_public_path__ + "static/media/waterfalls4.778fde1f.webp";